import { type GetBalanceCurrencyDTO, useIntl } from '@capsicum/common';
import { type MainCurrencies } from '@capsicum/socios-core';

import { useNCWSendAmount } from './useNCWSendAmount';

export const useNCWSendChilizAmount = (chilizBalanceRaw?: GetBalanceCurrencyDTO, currencies?: MainCurrencies) => {
	const { $t } = useIntl();
	const intlText = {
		balance: $t('ncWallet.send.assetSelector.balance'),
		buttonText: $t('ncWallet.send.assetSelector.continue'),
		pageTitle: $t('ncWallet.send.enterAmount.title')
	};

	const { conversionAltPrice, convertedDefaultPrice, error, inputValue, setError, setInputValue } = useNCWSendAmount(
		chilizBalanceRaw,
		currencies
	);

	return {
		conversionAltPrice,
		convertedDefaultPrice,
		error,
		inputValue,
		intlText,
		setError,
		setInputValue
	};
};
